var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, } from 'react';
import { ENTER_KEY } from '#constants';
import { C } from '#integrations';
import styles from './Tr.module.css';
export const Tr = ({ 'aria-rowindex': ariaRowindex, children, className, 'data-testid': testId, elementRef, isFocusable, isHeadRow, isOdd, isSelected, onClick, shouldFocusRow, virtualMarginBottom, virtualMarginTop, }) => {
    _react_refresh_temp_2();
    const ref = useRef(null);
    useEffect(() => {
        if (isFocusable && shouldFocusRow) {
            if (elementRef?.current) {
                elementRef.current.focus();
            }
            if (ref.current) {
                ref.current.focus();
            }
        }
    }, [elementRef, isFocusable, shouldFocusRow]);
    return (_jsx("tr", { className: C(styles.Container, !isHeadRow && isSelected && styles.Selected, isHeadRow && styles.HeadRow, !isHeadRow && isOdd && styles.Odd, className), "data-testid": `table-row-${testId}`, onClick: onClick, onKeyDown: (event) => {
            switch (event.key) {
                case ENTER_KEY: {
                    if (onClick) {
                        onClick(event);
                    }
                    break;
                }
            }
        }, ref: elementRef || ref, ...(!isHeadRow && {
            // Only the roving-active row is a tab stop; the table is
            // navigated with arrows, so Tab moves in/out as a single stop.
            tabIndex: isFocusable ? 0 : -1,
        }), ...(virtualMarginTop && {
            style: { marginTop: virtualMarginTop.toString() + 'px' },
        }), ...(virtualMarginBottom && {
            style: { marginBottom: virtualMarginBottom.toString() + 'px' },
        }), ...(ariaRowindex && { 'aria-rowindex': ariaRowindex }), children: children }));
};
_react_refresh_temp_1 = Tr;
$RefreshReg$(_react_refresh_temp_1, "Tr");
_react_refresh_temp_2(Tr, "8uVE59eA/r6b92xF80p7sH8rXLk=");
